import { render } from "./Products.vue?vue&type=template&id=fd4a6f2c"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"

import "./Products.vue?vue&type=style&index=0&id=fd4a6f2c&lang=css"
script.render = render

export default script